import React from 'react';
import type { IconProps } from '../types';

export const Controls = (props: IconProps) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      id="Controls"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle
        id="Oval"
        stroke="currentColor"
        cx="9"
        cy="3.34782609"
        r="1.73913043"
      ></circle>
      <line
        x1="10.7373913"
        y1="3.34782609"
        x2="16.4095652"
        y2="3.34782609"
        id="Path"
        stroke="currentColor"
      ></line>
      <line
        x1="1.62695652"
        y1="3.34782609"
        x2="7.2573913"
        y2="3.34782609"
        id="Path"
        stroke="currentColor"
      ></line>
      <g
        id="Group-26"
        transform="translate(9.0183, 9) scale(-1, 1) translate(-9.0183, -9)translate(1.627, 7.2609)"
        stroke="currentColor"
      >
        <circle
          id="Oval"
          transform="translate(3.8948, 1.7391) scale(-1, 1) translate(-3.8948, -1.7391)"
          cx="3.89478261"
          cy="1.73913043"
          r="1.73913043"
        ></circle>
        <line
          x1="5.63043478"
          y1="1.73913043"
          x2="14.7826087"
          y2="1.73913043"
          id="Path"
          transform="translate(10.2065, 1.7391) scale(-1, 1) translate(-10.2065, -1.7391)"
        ></line>
        <line
          x1="0"
          y1="1.73913043"
          x2="2.15217391"
          y2="1.73913043"
          id="Path"
          transform="translate(1.0761, 1.7391) scale(-1, 1) translate(-1.0761, -1.7391)"
        ></line>
      </g>
      <circle
        id="Oval"
        stroke="currentColor"
        cx="7.26086957"
        cy="14.6521739"
        r="1.73913043"
      ></circle>
      <line
        x1="8.99652174"
        y1="14.6521739"
        x2="16.4095652"
        y2="14.6521739"
        id="Path"
        stroke="currentColor"
      ></line>
      <line
        x1="1.62695652"
        y1="14.6521739"
        x2="5.52173913"
        y2="14.6521739"
        id="Path"
        stroke="currentColor"
      ></line>
    </g>
  </svg>
);

export default Controls;
